import type {UavPointCloud, UavPointCloudCreate, UavPointCloudUrls} from '@/domain/entities/UavPointCloud';
import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {UavPointCloudDto} from './UavPointCloudDto';
import {toDomain, toDto} from './UavPointCloudMappers';

const PATH = 'uav-point-clouds/';

export class RestUavPointCloudRepository implements UavPointCloudRepository {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly multipartClient: HttpClient,
  ) {}
  create = async (entity: UavPointCloudCreate) => {
    const dto = await this.httpClient.post<UavPointCloudCreate, UavPointCloudDto>(PATH, entity);
    return toDomain(dto);
  };
  getByForestMassUuid = async (forestMassUuid: string) => {
    const dtos = await this.httpClient.get<Array<UavPointCloudDto>>(`${PATH}?forestMassUuid=${forestMassUuid}`);
    if (dtos.length !== 0) {
      return toDomain(dtos[0]);
    }
    return undefined;
  };
  get = async (uuid: string) => {
    const dto = await this.httpClient.get<UavPointCloudDto>(`${PATH}${uuid}`);
    return dto ? toDomain(dto) : undefined;
  };
  delete = async (uuid: string) => {
    await this.httpClient.delete(`${PATH}${uuid}`);
  };
  patch = async (domain: UavPointCloud): Promise<UavPointCloud> => {
    const dto = await this.httpClient.patch<UavPointCloudDto, UavPointCloudDto>(`${PATH}${domain.uuid}`, toDto(domain));
    return toDomain(dto);
  };
  getUrls = async (uuid: string) => {
    return await this.httpClient.get<UavPointCloudUrls>(`${PATH}${uuid}/get-urls`);
  };
  upload = async (url: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    await this.multipartClient.post(url, formData);
  };
}
